var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"400","value":"true"},on:{"click:outside":_vm.close}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('etags')))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.$t('selectAnEtagToChange')))]),_c('EtagList',{attrs:{"etags":_vm.etags},on:{"selected":_vm.selected}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }